function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const PROD_CLIENT_ID = '632561651711-4on9e5dap9a24cf1p14hbof1geqlje1f.apps.googleusercontent.com';
const NON_PROD_CLIENT_ID = '900080987091-77oepan8lgolf2cmeh4uhf56d72dnilk.apps.googleusercontent.com';
async function googleOneTap(_ref) {
  var _window, _window$google;
  let clickEvent = _ref.clickEvent,
    _ref$trackingCallback = _ref.trackingCallback,
    trackingCallback = _ref$trackingCallback === void 0 ? () => null : _ref$trackingCallback,
    _ref$trackingBaseProp = _ref.trackingBaseProperties,
    trackingBaseProperties = _ref$trackingBaseProp === void 0 ? {} : _ref$trackingBaseProp;
  const isGoogleAccountOnPage = (_window = window) === null || _window === void 0 ? void 0 : (_window$google = _window.google) === null || _window$google === void 0 ? void 0 : _window$google.accounts;
  if (!isGoogleAccountOnPage) {
    trackingCallback('Google One Tap Display', {
      isDisplayed: false,
      notDisplayedReason: 'Google script not loaded in time'
    });
    console.error('Googe Account client not loaded on the page. Did you add the script tag? See fe-helper docs https://github.com/domain-group/fe-helper/blob/master/docs/DOCUMENTATION.md#googleOneTap.');
    return;
  }
  let promptParentId;
  const divRef = document.createElement('div');
  if (clickEvent) {
    promptParentId = 'google-one-tap-shortlist-holder';
    divRef.style.position = 'absolute';
    divRef.style.left = "".concat(clickEvent.pageX - 391, "px");
    divRef.style.top = "".concat(clickEvent.pageY, "px");
  } else {
    promptParentId = 'google-one-tap-default-place-holder';
    divRef.style.position = 'fixed';
    divRef.style.right = '20px';
    divRef.style.top = '20px';
    divRef.style.width = '391px';
  }
  divRef.style.zIndex = '10000';
  divRef.setAttribute('id', promptParentId);
  document.getElementsByTagName('body')[0].appendChild(divRef);
  return new Promise(resolve => {
    window.google.accounts.id.initialize({
      prompt_parent_id: promptParentId,
      client_id: window.location.host === 'www.domain.com.au' ? PROD_CLIENT_ID : NON_PROD_CLIENT_ID,
      callback: credentialResponse => {
        resolve(credentialResponse.credential);
      }
    });
    window.google.accounts.id.prompt(notification => {
      if (notification.isDisplayMoment()) {
        trackingCallback('Google One Tap Display', _objectSpread(_objectSpread({}, trackingBaseProperties), {}, {
          isDisplayed: notification.isDisplayed(),
          notDisplayedReason: notification.getNotDisplayedReason()
        }));
      } else if (notification.isSkippedMoment()) {
        trackingCallback('Google One Tap Skipped', _objectSpread(_objectSpread({}, trackingBaseProperties), {}, {
          skippedReason: notification.getSkippedReason()
        }));
      } else if (notification.isDismissedMoment()) {
        trackingCallback('Google One Tap Dismissed', _objectSpread(_objectSpread({}, trackingBaseProperties), {}, {
          dismissedReason: notification.getDismissedReason()
        }));
      }
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        resolve(undefined);
      }
    });
  });
}
export default googleOneTap;